// extracted by mini-css-extract-plugin
export default {"exit-button-data-check":"ExitButton_style_exit-button-data-check__VGqpQ","rotate":"ExitButton_style_rotate__t3UZo"};